<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center font-weight-bold"
    >
      Master Lokasi Kecamatan      
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <!-- tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/data-master/master-lokasi"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Provinsi</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/master-lokasi-kota"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Kota/Kab</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/data-master/master-lokasi-kecamatan"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Kecamatan</router-link>
      </li>
    </ul>
    <!-- Data kecamatan -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>

            <input
              type="text"
              name
              id
              class="form-control"
              v-model="search"
              placeholder="Cari Data ..."
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #name="{item}">
              <td class="py-2 text-left">{{item.name ? item.name : "-"}}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
               <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Provinsi</label>
              <multiselect
                label="name"
                required
                placeholder="Pilih Provinsi"
                @input="pilihProvinsi"
                v-model="multi_provinsi"
                :options="optionProvinsi"
              ></multiselect>              
            </CCol>
            <br />
            <CCol sm="12" class="mt-2">
              <label for class="font-weight-bold">Kota/Kabupaten</label>

              <multiselect
                label="name"
                required
                placeholder="Pilih Kota / Kabupaten"
                @input="pilihKotaKab"
                v-model="multi_kota_kab"
                :options="optionKotaKabSelect"
              ></multiselect>
              <span v-if="$v.formData.idKotaKab.$error" class="text-danger">
                *Mohon pilih Kota/Kabupaten
              </span>
            </CCol>
            <CCol sm="12">
              <label for="nama_dokument" class="font-weight-bold">Nama Kecamatan</label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.name.$error,                     
                }"
                id="nama_kec"
                placeholder="Masukkan Nama Kecamatan"                  
                v-model="formData.name"
                @input="setNamaKecamatan($event.target.value)"                            
              />                 
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.status"
                    checked
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data kecamatan -->
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import KecamatanService from "../../services/datamaster/kecamatan.service";
import KotaKabupatenService from "../../services/datamaster/kota-kabupaten.service";
import ProvinsiService from "../../services/datamaster/provinsi.service";
// mixins
import { AlertUtils } from "../../mixins/AlertUtils";
import { Pagination } from "../../mixins/Pagination";
import { Location } from "../../mixins/lokasi/Location";
import { parse } from '@babel/core';

const fields = [

  {
    key: "no",
    _style: "width: 8%;"
  },

  {
    key: "name",
    label: "Nama",
    _style: "text-align: left"
  },

  {
    key: "status",
    _style: " text-align: center"
  },

  {
    key: "aksi",
    _style: "width:15%; text-align: center"
  }
  
];

export default {
  mixins: [AlertUtils, Pagination, Location],
  data() {
    return {
      actionPost: "",
      formData: {
        kode: "",
        name: "",
        status: "",
        idKecamatan: "",
        idKotaKab: ""
      },
      optionKotaKabSelect : [],
      fileName: "Choose File...",
      fields,
      details: [],
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  validations: {
    formData: {
      idKotaKab: { required },
      name: { required },
      status: { required }
    }
  },

  mounted() {
    this.getData("0", this.pageSize, this.search)
    this.getAllProvinsi();
    this.getAllKotaKab();
    this.roleData();
  },

  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/data-master/master-lokasi' );  
      this.role_status = data;
    },
    setNamaKecamatan(value) {
      this.formData.name = value;
      this.$v.formData.name.$touch();           
      if(!this.$v.formData.name.$error) {
        document.getElementById('nama_kec').classList.add('is-valid')
      }
    },
    
    pageChange() {
      this.getData(currentPage);
    },
    
    pilihKotaKab(val) {
      this.formData.idKotaKab = val.id_kota_kab;
      this.$v.formData.idKotaKab.$reset() 
    },

    pilihProvinsi(val) {
      var kotakab = this.optionKotaKab.filter(el => el.id_provinsi === val.idProvinsi);
      
      this.optionKotaKabSelect = kotakab;
      this.multi_kota_kab = [];

      // comment console console.log(kotakab);
      // comment console console.log("ini data kota kabs"+kotakabs);
      // comment console console.log(val.idProvinsi)
    },
    
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            KecamatanService.deleteKecamatan(this.formData)
              .then(response => {
                // comment console console.log(response);

                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();

                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      KecamatanService.getKecamatan(currentPage,pageSize,filter)
      .then(response => {
        loader.hide();

          // comment console console.log(response.data.data.content);

          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.multi_provinsi = [];
      this.multi_kota_kab = [];
      this.optionKotaKabSelect = [];
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";      
      setTimeout(() => {        
        this.multi_provinsi = this.optionProvinsi.find(el => parseInt(el.idProvinsi) === parseInt(this.formData.idProvinsi));
        this.multi_kota_kab = this.optionKotaKab.find(el => parseInt(el.id_kota_kab) === parseInt(this.formData.idKotaKab))
        this.optionKotaKabSelect = this.optionKotaKab.filter(el => parseInt(el.id_provinsi) === parseInt(this.formData.idProvinsi));
      }, 1000);      
      this.multi_kota_kab = [
        {
          name : item.nama_provinsi
        }
      ]
    },

    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);
        }           
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }           
      }    
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      // comment console console.log(formData);
      // comment console console.log("post");

      KecamatanService.postKecamatan(formData)
        .then(response => {
          loader.hide();

          this.myModal = false;
          this.alertSuccess();
          this.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();

          // comment console console.log(error);
          this.alertError(error.response.data.message);
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);

      KecamatanService.putKecamatan(this.formData)
        .then(response => {
          this.myModal = false;

          this.alertEditSuccess();

          this.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError(error.response.data.message);
        });
    },

    closeModal() {
      this.myModal = false;
      this.$v.$reset();
      document.getElementById('nama_kec').classList.remove('is-valid');
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
